// ============================================================================
// DOCUMENT OUTPUT PROFILES (ADR-0001) — the Print Layouts screen, slice GRC-2
// ============================================================================
// One profile per property × document type. Layouts are built in; the profile
// styles them: logo, name, header lines, terms, footer, font size, optional
// fields hidden or relabelled. Empty text prints the built-in default.

export const PRINT_LAYOUTS_MODULE = 'pms-print-layouts';

export type OutputDocumentType = 'GRC';

export interface OutputOption {
  code: string;
  label: string;
}

export interface OutputProfile {
  propertyId: string;
  documentType: OutputDocumentType;
  documentLabel: string;
  /** False while the property prints with built-in defaults. */
  isSaved: boolean;
  layoutCode: string;
  hasLogo: boolean;
  displayName: string | null;
  headerLines: string | null;
  termsText: string | null;
  footerText: string | null;
  fontScale: number;
  hidden: string[];
  labels: Record<string, string>;
  rowVersion: number;
  updatedAt: string | null;
  updatedByName: string | null;
  defaultDisplayName: string;
  defaultHeaderLines: string;
  defaultTermsText: string;
  layouts: OutputOption[];
  optionalFields: OutputOption[];
}

export interface SaveOutputProfileRequest {
  layoutCode: string;
  displayName: string | null;
  headerLines: string | null;
  termsText: string | null;
  footerText: string | null;
  fontScale: number;
  hidden: string[];
  labels: Record<string, string>;
  rowVersion: number;
}

export const FONT_SCALES: { value: number; label: string }[] = [
  { value: 0.85, label: 'Small' },
  { value: 1, label: 'Normal' },
  { value: 1.15, label: 'Large' },
];
